import { validateInputs } from "../utils/form";

export default function () {
  const dialogSuccess = document.getElementById("modalSuccessMessage");
  const dialogError = document.getElementById( "modalErrorMessage");
  const form = document.querySelector("#job-form");
  const attachmentLabel = document.querySelector("[data-input-file-label");
  const labelAttachment = document.querySelector("#attachment-label")?.getAttribute("aria-label");

  if (form) {
    attachment.addEventListener("change", (event) => {
      let file = null;

      if (attachment.files && attachment.files.length >= 1) {
        file = attachment.files[0];
        attachmentLabel.innerText = file.name;
      }
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();

      const isValid = validateInputs(form);

      if(isValid) {
        const formData = new FormData(form);
        let result;

        try {
          const response = await fetch('', {
            method: "POST",
            body: formData,
          });
          result = await response.json();
        } catch (error) {
          dialogError.showModal();
        }

        // success
        if (result?.success) {
          dialogSuccess.showModal();
          form.reset();
          attachmentLabel.innerText = labelAttachment;
          return;
        }

        // error
        dialogError.showModal();
      }
    });
  }
}
